module.exports = __webpack_public_path__ + "static/media/BK.2cf95c68.svg";